module.exports = __webpack_public_path__ + "static/sararenteria-72bf3d7562085effc58c78bf5587be77.jpg";